import React from 'react'
import Grid from '@material-ui/core/Grid'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import { withStyles } from '@material-ui/core/styles'
import InputWrapper from './InputWrapper'

const RadioWrapper = ({
  label,
  id,
  error,
  isRequired = false,
  onChange,
  items = [],
  value,
  id: name,
  disabled = false,
  direction = `row`,
  forceFullLabel = false,
  align = `left`,
  type = ``,
  md = 12,
  xs = 12,
}) => {
  return (
    <InputWrapper
      label={label}
      error={error}
      isRequired={isRequired}
      forceFullLabel={forceFullLabel}
      align={align}
      type={type}
      md={md}
      xs={xs}
      disabled={disabled}
      withPadding={true}
    >
      <RadioGroup
        aria-label={name}
        name={name}
        value={value}
        onChange={({ target: { value, name } }) => {
          onChange({ name, value: isNaN(value) ? value : Number(value), id })
        }}
        id={id}
      >
        <Grid container direction={direction}>
          {items.map(({ value: itemValue, label: itemLabel }, i) => (
            <Grid key={`${name}-${i}-${itemLabel}`} item>
              <FormControlLabel
                disabled={disabled}
                key={`${name}-${i}-${itemLabel}`}
                value={itemValue}
                control={
                  <Radio
                    checked={itemValue === value}
                    color="primary"
                    inputProps={{
                      autoFocus: false,
                    }}
                  />
                }
                label={itemLabel}
              />
            </Grid>
          ))}
        </Grid>
      </RadioGroup>
    </InputWrapper>
  )
}

const styles = ({ spacing, palette: { primary } }) => ({
  checked: {
    '& svg': {
      fill: primary.main,
    },
  },
  margin: {
    marginLeft: spacing(1),
  },
  marginRight: {
    marginRight: spacing(2),
  },
  marginTop: {
    marginTop: spacing(1),
  },
})

export default withStyles(styles)(RadioWrapper)
